// {service}.{env}.ducatprotocol.com

import { getDomainEnv } from './config.utils';

const serviceConfigMap = {
  prod: {
    validator: 'validator.ducatprotocol.com',
    liq_validator: 'liquidations.ducatprotocol.com',
    guardian: 'wss://guardian-{network}-{num}.ducatprotocol.com',
    price: 'https://price.ducatprotocol.com',
    quote: 'https://quote.ducatprotocol.com',
  },
  staging: {
    validator: 'validator.staging.ducatprotocol.com',
    liq_validator: 'validator.staging.ducatprotocol.com',
    guardian: 'wss://guardian-{network}-{num}.staging.ducatprotocol.com',
    price: 'https://price.staging.ducatprotocol.com',
    quote: 'https://quote.staging.ducatprotocol.com',
  },
  dev: {
    validator: 'validator.staging.ducatprotocol.com',
    liq_validator: 'validator.staging.ducatprotocol.com',
    guardian: 'wss://guardian-{network}-{num}.staging.ducatprotocol.com',
    price: 'https://price.staging.ducatprotocol.com',
    quote: 'https://quote.staging.ducatprotocol.com',
  },
};

const domainEnv = getDomainEnv();

export const SERVICE_URLS = serviceConfigMap[domainEnv];
